import { get, handleError } from '@/lib/http-adapter';

export const checkCustomerHistory = async (filters?: {
  user_id?: string;
  email?: string;
  phone?: string;
  country_code?: string;
}) => {
  try {
    const response = await get<{
      is_new_customer: boolean;
    }>('public/customer-history', { params: filters });

    return response?.is_new_customer ?? true;
  } catch (error) {
    handleError(error);
  }
};
